<template>
  <div id="app">
    <nav-header v-if="navFlag"></nav-header>
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-else/>
  </div>
</template>
<script>
import NavHeader from './components/navHeader.vue';
export default {
  components: {
    NavHeader
  },
  name: 'App',
  data(){
    return {
      navFlag: false
    }
  },
  mounted() {
    const _this = this
    _this.navFlag = window.location.href.toString().indexOf('login') == -1 ? true : false
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
* {
  padding: 0;
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue